export function displayHtmlInit() {

    $(document).ready(function () {
        $('html').addClass('js_ready');
    });

}